export default __webpack_public_path__ + "static/media/banner-xpert2.9d28b4eb.png";